<template>
	<div class="grid xl:grid-cols-6 gap-4 max-w-7xl mx-auto py-6">
		<div class="col-span-full mt-2">
			<h4 class="text-xl font-bold text-surface-600 antialiased">{{ $t('pages.devices.device.summary.device_data') }}</h4>
		</div>

		<div class="col-span-2">
			<Card>
				<template #title>{{ $t('common.details') }}</template>
				<template #content>
					<DescriptionList class="-mt-6">
						<DescriptionListItem :term="$t('common.serial_number')" :details="device?.serial_number"/>
						<DescriptionListItem :term="$t('common.type')" :details="device?.device_type?.name"/>
						<DescriptionListItem :term="$t('common.model')" :details="device?.device_model?.name"/>
						<DescriptionListItem :term="$t('common.manufacturer')" :details="device?.device_manufacturer?.name"/>
						<DescriptionListItem :term="$t('common.company')" :details="device?.company?.name"/>
						<DescriptionListItem :term="$t('common.asset')" :details="activeAsset?.name" :to="activeAsset?.id ? {name: 'assets.show', params: { asset: activeAsset?.id }} : undefined"/>
						<DescriptionListItem :term="$t('common.designation')" :details="device?.designation"/>
					</DescriptionList>

					<DescriptionList :title="$t('common.firmware')" class="mt-10">
						<DescriptionListItem :term="$t('common.type')" :details="device?.current_firmware?.firmware_type?.name"/>
						<DescriptionListItem :term="$t('common.current_version')" :details="device?.current_firmware?.version_number"/>
					</DescriptionList>
				</template>
			</Card>
		</div>

		<div class="max-h-[37rem] col-span-2 row-span-2">
			<DevicesBeingUpdatedList :device="$route.params.device"/>
		</div>

    <div class="max-h-[37rem] col-span-2 row-span-2">
      <DevicesConfigUpdatesList :device="$route.params.device"/>
    </div>

		<div class="h-full max-h-[37rem] col-span-2 row-span-2 flex items-stretch">
      <DeviceBeingUpdatedStatusChart/>
		</div>

	</div>
</template>

<script>
import DeviceBeingUpdatedStatusChart from "@/Widgets/Charts/DeviceBeingUpdatedStatusChart.vue";
import DevicesBeingUpdatedList from "@/Widgets/Lists/DevicesBeingUpdatedList.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";
import DescriptionList from "@/Components/DescriptionList.vue";
import DescriptionListItem from "@/Components/DescriptionListItem.vue";
import DevicesConfigUpdatesList from "@/Widgets/Lists/DevicesConfigUpdatesList.vue";


export default {
	name: "DeviceSummary",
	data() {
		return {
			device: undefined,
			params: {
				include: [
					'deviceType',
					'company',
					'assets',
					'deviceManufacturer',
					'deviceModel',
					'currentFirmware',
					'activitiesCount',
					'deviceModelCount',
					'deviceTypeCount',
					'deviceRevision',
					'deviceRevisionCount',
				],
			},
		}
	},
	computed: {
		...mapStores(useDevicesStore),
		activeAsset() {
			return this.device?.assets?.find(a => !!a.pivot?.active) ?? this.device?.assets?.[0] ?? null;
		},
	},
	methods: {},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.device === 'NEW') {
						this.device = {};
					} else {
						this.device = await this.devicesStore.showDevice(this.$route.params.device, this.params);
					}
				} else {
					this.device = undefined;
				}
			},
			immediate: true,
		}
	},
	components: {
    DevicesConfigUpdatesList,
		DescriptionListItem,
		DescriptionList,
		DevicesBeingUpdatedList,
		DeviceBeingUpdatedStatusChart,
	},
	async mounted() {
	}
}

</script>

<style scoped>

</style>
